module.exports = __webpack_public_path__ + "static/media/final-de-ano-2026.449a808b.png";